"use client";

import Image from "next/image";
import Link from "next/link";
import whatsAppLogo from "../../public/assets/whatsAppLogo2.png"

const ContactCard = ({
  icon1: Icon1,
  title1,
  contact1,
  link1,
  icon2: Icon2,
  title2,
  contact2,
  link2,
  whatsappLink,
}) => {
  return (
    <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border border-gray-200 w-full">
      <div className="flex flex-col space-y-4">
        {/* Titles */}
        <p className="text-gray-600 text-xs md:text-sm">
          {title1} & {title2}
        </p>

        {/* Contact Links */}
        <div className="flex flex-wrap items-center space-x-1 md:space-x-2">
          {/* First Contact */}
          <Icon1 className="text-blue-500" />
          <Link
            href={link1}
            className="text-blue-500 font-medium text-sm md:text-lg hover:text-blue-600 no-underline"
          >
            {contact1}
          </Link>

          <span className="text-gray-600 mx-2">|</span>

          {/* Second Contact */}
          <Icon2 className="text-blue-500" />
          <Link
            href={link2}
            className="text-blue-500 font-medium text-sm md:text-lg hover:text-blue-600 no-underline"
          >
            {contact2}
          </Link>

          <span className="text-gray-600 mx-2 md:mx-4">|</span>

          {/* WhatsApp */}
          {whatsappLink && (
            <Link href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <div className="relative w-7 h-7 md:w-10 md:h-10 rounded-full overflow-hidden bg-green-400">
                <Image
                  src={whatsAppLogo}
                  alt="WhatsApp"
                  fill
                  style={{ objectFit: "cover" }}
                />
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
